<template>
  <div>
    <b-modal
      v-model="showModal"
      size="xl"
      content-class="modal-content-dashboard"
      no-close-on-backdrop
    >
      <div slot="modal-header">
        <h2>{{ $t("template.hatch_enrichment_modal_title", "Hatch Enrichment") }}</h2>
        <div class="modal-header__hide" @click.prevent="hideModal">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            ></path>
            <path d="M0 0h24v24H0z" fill="none"></path>
          </svg>
        </div>
      </div>
      <div slot="modal-footer">
        <button class="bttn bttn--lg bttn--blue tw-mx-auto" @click.prevent="hideModal">
          {{ $t("template.close", "Close") }}
        </button>
      </div>

      <!-- Modal Content Here -->
      <div v-if="loading">Loading...</div>
      <div v-else-if="hasData">
        <!-- Display the enriched data here -->
        <div v-if="profiles.length">
          <div v-for="(profile, index) in profiles" :key="index" class="mb-3">
            <ProfileView :profile="profile" />
          </div>
        </div>

        <div v-if="jobs.length">
          <div v-for="(job, index) in jobs" :key="index" class="mb-3">
            <JobView :job="job" />
          </div>
        </div>
      </div>
      <div v-else>No data available.</div>
    </b-modal>
  </div>
</template>

<script>
import urls from "@/constants/urls";
import { notificationsMixin } from "@/mixins";
import axios from "axios";
import JobView from "./job-view.vue";
import ProfileView from "./profile-view.vue";

export default {
  name: "HatchEnrichmentModal",

  mixins: [notificationsMixin],

  components: {
    JobView,
    ProfileView,
  },

  data() {
    return {
      showModal: false,
      loading: false,
      data: {
        data: {
          profiles: [],
          jobs: [],
        },
      },
    };
  },

  computed: {
    oid() {
      return localStorage.getItem("orgId");
    },

    profiles() {
      return this.data?.data.profiles;
    },

    jobs() {
      return this.data?.data.jobs;
    },

    hasData() {
      return this.profiles?.length > 0 || this.jobs?.length > 0;
    },
  },

  methods: {
    open(did, cid) {
      this.showModal = true;
      this.requestHatchEnrichment(did, cid);
    },

    hideModal() {
      this.showModal = false;
      this.data = {
        data: {
          profiles: [],
          jobs: [],
        },
      };
      this.loading = false;
    },

    requestHatchEnrichment(did, cid) {
      if (this.jobs.length === 0) {
        this.loading = true;
      }

      const data = {
        donation_id_list: [Number(did)],
      };

      axios
        .post(urls.hatchEnrichment(this.oid, cid), data)
        .then((response) => {
          this.data = response.data;
          if (this.jobs.length > 0 || this.profiles.length == 0) {
            this.runStatusCheck(did, cid);
          }
        })
        .catch((error) => {
          console.error("Error requesting Hatch enrichment:", error);
          this.$_notificationsMixin_handleCatch(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    runStatusCheck(did, cid) {
      setTimeout(() => {
        this.requestHatchEnrichment(did, cid);
      }, 5000); // Check every 5 seconds
    },
  },
};
</script>
